import { FC } from 'react';
import { useNavigate } from 'react-router';
import { Heading } from './Heading';

type Props = {
  id: string;
  heroImage?: string;
  title: string;
  description?: string;
  gradientPlaceholder: string;
};

export const CampaignCard: FC<Props> = ({
  id,
  heroImage,
  title,
  description,
  gradientPlaceholder,
}) => {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate(`/client/details/campaign/${id}`);
  };

  return (
    <div className="basis-1/4 p-4">
      <div
        className="shadow-md rounded-md overflow-hidden cursor-pointer hover:scale-105 hover:shadow-md transition-all duration-300 border border-gray-200"
        onClick={handleClick}
      >
        <Heading
          mediaUrl={heroImage}
          title={title}
          gradientPlaceholder={gradientPlaceholder}
        />
        <div className="p-4 flex flex-col justify-between flex-1">
          <div className="flex flex-col grow-1 gap-1">
            <div className="text-xl">{title}</div>
            <div className="text-sm text-gray-500 h-12 overflow-hidden text-ellipsis line-clamp-2">
              {description}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
